import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarmElement,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';
import { P00039DataRxTxIndex } from '../../P00039Sync';

export function P0003606Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('iphSAlarme') === 1) {
    if (getValue('iphSFinBidon') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_PH,
        functionalityTitle: 'P0003606.dashboard.ph',
        title: 'P0003606.status.bidon',
      });
    }

    if (getValue('iphSProtectionSurdosage') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_PH,
        functionalityTitle: 'P0003606.dashboard.ph',
        title: 'P0003606.status.securiteSurdosage',
        ctaTitle: 'P0003606.status.securiteSurdosage.value',
        ctaFn: (editValue: any) => {
          editValue(
            P00039DataRxTxIndex.InjectionPh_Controle,
            'iphCAckUtilisateur',
            1,
          );
        },
      });
    }

    if (getValue('iphSSecuritePh') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_PH,
        functionalityTitle: 'P0003606.dashboard.ph',
        title: 'P0003606.status.securitePh',
      });
    }

    if (masterClass.hasProduct(pool, productClass) === 2) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_PH,
        functionalityTitle: 'P0003606.dashboard.ph',
        title: 'P0003606.status.connexionProduit',
      });
    }
  }

  return res;
}
